import { SvgIcon } from "@mui/material"

import { ReactComponent as Circle } from "./circle.svg"

export const CircleIcon = (props) => {
    return (
        <SvgIcon component={Circle} {...props} inheritViewBox />
    )
}
